<style>

</style>

<script>
    
    import MiniMasonry from "minimasonry";

    import carousel from '../../misc/carousel';
    import shopifyProductCard from '../../shopify/shopifyProductCard';
    import socialShare from '../../socialShare';
    import snackbar from '../../misc/snackbar';
    
    import {shopifyProductStructuredDataMixin} from "../../../mixins/shopify/shopifyProductStructuredDataMixin";
    import {shopifyHelperMixin} from "../../../mixins/shopifyHelperMixin";
    
    export default {
        props: ['product', 'related_collections'],
        components: {
            carousel,
            shopifyProductCard,
            socialShare,
            snackbar,
        },
        mixins: [shopifyProductStructuredDataMixin, shopifyHelperMixin],
        data: function () {
            return {
                related_products: {
                    data: [],
                    groups: [],
                    loading: false,
                    pagination: {
                        per_page: 32,
                        page: 1
                    },
                    order_by: '',
                    order_dir: -1,
                    load_more: true,
                    needs_update: true,
                    masonry: null,
                    masonry_container: '.related-products-masonry-grid',
                    masonry_needs_init: false,
                    match_all_keywords: true,
                    map: {}
                },
                selected_group: null,
            }
        },
        computed: {
            
        },
        created: function () {
            this.getRelatedProducts();
        },
        mounted: function () {
            var self = this;
            
            document.addEventListener('scroll', function () {
                if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 1000) {
                    self.loadMoreProducts();
                }
            });
        },
        methods: {
            getRelatedProducts: function () {
                var self = this;
                self.related_products.loading = true;
                var url = '/api/v5/shopify/products/' + this.product.id + '/related';

                var params = {
                    page: this.related_products.pagination.page,
                    per_page: this.related_products.pagination.per_page,
                    match_all_keywords: this.related_products.match_all_keywords,
                    with_store: true,
                    exclude_store_id: this.product.shop_id,
                    min_imported_at: moment().subtract(14, 'day').format()
                };

                axios.get(url, {params: params}).then(function (response) {
                    self.related_products.loading = false;
                    self.related_products.needs_update = false;
                    var data = response.data.data;
                    if (params.page === 1) {
                        self.related_products.data = [];
                        self.related_products.map = {};
                    }
                    self.addProducts(data);
                    if (!data.length) {
                        self.related_products.load_more = false;
                    }
                    
                    if(self.related_products.data.length){
                        Vue.nextTick(function(){
                            self.initMasonryGrid(self.related_products);
                        });
                    }
                    
                    if(response.data.match_all_no_results){
                        //If match all returns no results then set it to false
                        self.related_products.match_all_keywords = false;
                    }
                    
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.search = false;
                    self.related_products.needs_update = false;
                    self.showErrorMessage(error);
                });
            },
            loadMoreProducts: function(){
                if(this.related_products.loading || !this.related_products.load_more){
                    return;
                }
                this.related_products.pagination.page++;
                this.getRelatedProducts();
            },
            initMasonryGrid: function(obj){
                var self = this;
                if(obj.masonry){
                    obj.masonry.layout();
                } else {
                    var masonry = new MiniMasonry({
                        container: obj.masonry_container,
                        baseWidth: 210,
                        minify: false
                    });
                    obj.masonry = masonry;
                }
            },
            addProducts: function(products){
                for(var i=0; i < products.length; i++){
                    var product = products[i];
                    this.addProduct(product);
                }
            },
            addProduct: function(product){
                if(!this.related_products.map[product.id]){
                    this.related_products.data.push(product);
                    this.related_products.map[product.id] = 1;
                }
            },
        }
    };

</script>

<template>
    <div>
        
        <aside class="my-5" v-if="related_products.data.length">
            <div class="style-page-title text-center mb-4">Related products</div>
            <div>
                <div class="masonry-grid related-products-masonry-grid">
                    <div class="masonry-item" v-for="product in related_products.data" :key="product.id">
                        <shopify-product-card class="h-100 mb-1" :product="product" v-if="product"></shopify-product-card>
                    </div>
                </div>
            </div>
            <div class="py-4 text-center" v-if="related_products.loading">
                <i class="fas fa-spin fa-spinner fa-fw fs-14"></i>
            </div>
        </aside>            

        <social-share></social-share>
        <snackbar></snackbar>

    </div>

</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/shopify/productProfile/shopifyProductProfile2.vue